export const environment = {
  production: true,
  // apiUrl: 'https://gwtest.jobtrain.co.uk/api/'
  apiUrl: 'http://localhost:90/api/',
  LoginUrl: 'http://localhost:1338/api/'
};
